import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateHelper } from 'apps/idl/src/helpers';
import { IPatient } from 'apps/idl/src/modules/patients/model/IPatient';
import { PatientsService } from '../../../../../modules/patients/services/patients.service';
import { PatientHelper } from '../../../shared/helpers/patient.helper';

@Component({
  selector: 'di-ligne-patient',
  templateUrl: './ligne-patient.component.html',
  styleUrls: ['./ligne-patient.component.scss'],
})
export class LignePatientComponent implements OnInit {

  @Input()
  public patient: IPatient;

	@Input()
  public mobileViewForce? = false;

  @Output()
  public onClickLigne = new EventEmitter<string>();

  public adress = "";
  public age = "";
  public birthDate = "";
  public phoneNumber = "";
	public phoneNumberFixe = "";
  public isDeceased: boolean;
	public fullLastName: string;
	public fullFirstName:string;
	public gender: string = "";

  constructor(
		private svcPatient : PatientsService
	) { }

  ngOnInit() {
    const { street, zipCode, city } = this.patient || {};
    const addressParts = [
      street,
      [zipCode, city].filter(Boolean).join(' ')
    ].filter(Boolean);
    this.adress = addressParts.join(', ');
    this.gender = this.svcPatient.getPatientGender(this.patient.gender);
		this.fullLastName = PatientHelper.getFullNamePatient(this.patient); 
		this.fullFirstName = PatientHelper.getPatientFirstName(this.patient); 

		if(this.patient.birthDate){
      const birthDateFormatted: Date = new Date(this.patient.birthDate);
      const today: Date = new Date();
      this.age = `${DateHelper.calculateAge(birthDateFormatted, today) } ans`
      this.birthDate = `${birthDateFormatted.getDate()} ${birthDateFormatted.toLocaleString('fr-FR', {month: 'long'})} ${birthDateFormatted.getFullYear()}`
    }
    if(this.patient.phone)
      this.phoneNumber = `${this.patient.phone?.replace(/(.{2})/g, '$1 ') ?? ""}`
		if(this.patient.phoneFixe)
      this.phoneNumberFixe = `${this.patient.phoneFixe?.replace(/(.{2})/g, '$1 ') ?? ""}`
  }

  onClick(patientId: string): void {
    this.onClickLigne.emit(patientId);
  }

}
